import { render, staticRenderFns } from "./OnSecteursSousRegions.vue?vue&type=template&id=64ef28b3&"
import script from "./OnSecteursSousRegions.vue?vue&type=script&lang=js&"
export * from "./OnSecteursSousRegions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports